import { FC } from 'react';

interface CustomizedAxisTickProps {
  x: number;
  y: number;
  stroke: string;
  payload: {
    value: string;
  };
}

export const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }

  return Number(num.toFixed(2)).toString();
};

export const CustomizedAxisTick: FC<CustomizedAxisTickProps> = ({ x, y, stroke, payload }) => {
  return (
    <text x={x} y={y} dy={1} fill={stroke} fontSize={8} textAnchor="end">
      ${formatNumber(Number(payload.value))}
    </text>
  );
};
